<tooltip [text]="getFormattedDate()">
    {{ getMoment() }}
</tooltip>
